import React, { FC } from 'react';
import { PreviewProps } from './preview.types';

export const Preview: FC<PreviewProps> = ({ className, url }) =>
  url ? (
    <iframe className={className} height="100%" src={`${url}#pagemode=none`} title="pdf-preview" width="100%" />
  ) : null;
